import React from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {AppBar, Typography, Toolbar, Button, Avatar} from '@mui/material'
import logo from '../../utils/images/echo-logo.png'
import {useDispatch, useSelector} from 'react-redux'
import {logOut, logIn} from '../../features/userAuth/userAuth'

const Navbar = () => {
  const dispatch = useDispatch()
  const {isLoggedIn, currentUser}= useSelector((state)=> state.user)
  const navigate = useNavigate()
  // const currentUser = JSON.parse(localStorage.getItem('user'))?.result
  //  let isLoggedIn= currentUser!==(null || undefined)?true:false ;



const Logout =() =>{
  navigate('/login')
  dispatch(logOut())
}

const Login =(e) => {
  navigate('/login')
  dispatch(logIn())
}
  return (
    <AppBar position='static' color='primary'>
  <Toolbar sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
    <div style={{display:'flex',justifyContent: 'center', alignItems: 'center', gap:'0.25rem'}}>
    <Avatar sx={{fontSize:'3rem'}}>
    <img src={logo} alt="logo" height='60px' />
    </Avatar>
   
    <Typography variant="h4" component="div" align='center' sx={{ display: { xs: 'none', sm:'block'}, alignSelf:'flex-end'}}>
       Echo
    </Typography>
    </div>
    { isLoggedIn &&
    ( <div style={{display:'flex',justifyContent: 'center', alignItems: 'center', gap:'0.25rem'}}> 
    <Typography variant="h6" component="div" align='center' sx={{ display: { xs: 'none', sm:'block'} }}>
       {currentUser?.Name}
    </Typography>
    <Avatar sx={{marginRight:'0.25rem'}}>{currentUser?.Name[0]}</Avatar>
    </div>
     )}
     <Link to='/login' style={{textDecoration:"none"}}>
    <Button variant='contained' onClick={isLoggedIn?Logout:Login} color={isLoggedIn?'secondary':'primary'}>{isLoggedIn ?'LOGOUT':'SIGNIN'}</Button>
</Link>
  </Toolbar>
</AppBar>
  )
}


export default Navbar